import { Link } from 'react-router';

// UI
import BackButton from '@components/back-button';
import Button from '@components/button';

// images
import LogoImg from '@assets/logo.png';

// styles
import css from './styles.module.css';

function PasswordUpdated() {
  return (
    <main className={css.resetPasswordRoot}>
      <div className={css.content}>
        <BackButton className={css.backButton} iconClassname={css.backIcon} />

        <img src={LogoImg} alt="logo" className={css.logo} />
        <h1 className={css.title}>
          Your password has been successfully updated 🎉
        </h1>
        <p className={css.subtitle}>You can now login again</p>

        <Link to="/login">
          <Button type="submit" size="large" className={css.submitButton}>
            Login
          </Button>
        </Link>
      </div>
    </main>
  );
}

export default PasswordUpdated;
